import { Container } from 'pixi.js';
import { InventoryItemAmountLayout } from '../../layouts/common/InventoryItemAmountLayout';
import type { InventoryItem, ResourceMap } from '../app/resources/types';
import { formatAmountForInventory, setIconForInventory } from '../mainMenu/shopPage/utils/setIconForInventory';
import { applyLayoutState } from '../libs/layouts/populateLayouts/applyLayoutState';

export class InventoryItemAmountView extends Container {
  private readonly layout = new InventoryItemAmountLayout();

  constructor(
    private readonly itemType: InventoryItem,
    private readonly amount: number,
    withBubble = false,
  ) {
    super();

    const { root, icon, amountText } = this.layout;

    root.props({ parent: this });
    setIconForInventory(icon, itemType);
    formatAmountForInventory(amountText, itemType, amount);

    if (withBubble) applyLayoutState(this.layout, 'withBubble');
  }

  public getItemType(): InventoryItem {
    return this.itemType;
  }

  public getAmount(): number {
    return this.amount;
  }
}

export function createInventoryItemViews(resourceMap: ResourceMap): InventoryItemAmountView[] {
  return Object.entries(resourceMap).map(
    ([item, amount]) => new InventoryItemAmountView(item as InventoryItem, amount),
  );
}
